// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hand[data-v-33dac634]:hover{cursor:pointer}.right[data-v-33dac634]{float:right}", ""]);
// Exports
module.exports = exports;
